import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IChatManagementReport } from '../models'
import { addDealerType, DealerTypeFilter } from '../../ChatbotAnalytics/analyticsQuery'

export class GetChatbotManagementReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-reports/management', requesterInfo })
  }

  public async getReport(
    fromUtc: Date,
    toUtc: Date,
    includeTestDealers = false,
    dealerType?: DealerTypeFilter
  ): Promise<IChatManagementReport> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', fromUtc.toISOString())
    query.add('toUtc', toUtc.toISOString())
    query.add('includeTestDealers', String(includeTestDealers))
    addDealerType(query, dealerType)
    this.queryParams = query
    return await this.getAsync<IChatManagementReport>()
  }
}
